import { render, staticRenderFns } from "./WatcherArea.vue?vue&type=template&id=d416a064&scoped=true"
import script from "./WatcherArea.vue?vue&type=script&lang=ts"
export * from "./WatcherArea.vue?vue&type=script&lang=ts"
import style0 from "./WatcherArea.vue?vue&type=style&index=0&id=d416a064&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d416a064",
  null
  
)

export default component.exports